import { useCallback } from "react"
import { useVendedorApi } from "../../infra/vendedor"
import { useAppDispatch, useAppSelector } from "../../presentation/hooks/store-hooks"
import { setVendedoresState } from "../../application/states/vendedor"
import { useUIService } from "../ui"

export const useVendedorService = () => {
    const dispatch = useAppDispatch()
    // State
    const { currentUser } = useAppSelector((state) => state.user)

    // infra
    const { getVendedoresByAtivoApi } = useVendedorApi()

    // use-case
    const { setAlert } = useUIService()

    const setVendedores = useCallback(async () => {
        if (currentUser) {
            try {
                const IdUsuario = currentUser.IdUsuario;
                const IdCliente = currentUser.IdCliente;

                const getVendedores = await getVendedoresByAtivoApi(IdUsuario, IdCliente);

                dispatch(setVendedoresState(getVendedores));
            } catch (error: any) {
                // Não mostrar alerta para erros 500 (problemas no backend)
                // Apenas logar silenciosamente para não incomodar o usuário
                if (error?.response?.status !== 500) {
                    const errorMessage = error?.response?.data?.message 
                        || error?.response?.data?.error 
                        || error?.message 
                        || 'Erro ao buscar vendedores';
                    
                    setAlert({
                        message: errorMessage,
                        type: "error"
                    });
                }
                // Em caso de erro 500, apenas retorna sem fazer nada
            }
        }
    }, [currentUser, getVendedoresByAtivoApi, dispatch, setAlert]);

    return {
        setVendedores
    }
}